import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  Router,
  RouterStateSnapshot,
} from '@angular/router';
import { MsalService } from '@azure/msal-angular';
import { permissionConstants } from '../services';

@Injectable({
  providedIn: 'root',
})
export class RolesGuard {
  constructor(private authService: MsalService, private router: Router) {}

  canActivate(route: ActivatedRouteSnapshot): boolean {
    const expectedRoles = route.data['expectedRoles'];
    let roles =
      this.authService.instance.getAllAccounts()[0].idTokenClaims?.roles;

    // If the user has no roles (just AD access), route to error page.
    if (!roles) {
      this.redirectToErrorPage();
      return false;
    }

    // If the user does not have the needed roles but does have EC roles, redirect to EC.
    // Otherwise, route to error page.
    else if (!roles.some((r) => expectedRoles.includes(r))) {
      let hasECRoles = roles.some((role) => permissionConstants.energyCredits.includes(role));
      let hasQbuiltRoles = roles.some((role) => permissionConstants.qBuilt.includes(role));
      let hasQbuiltInspectorRoles = roles.some((role) => permissionConstants.qBuiltInspector === role);

      if (hasECRoles) {
        this.router.navigate(['energy-credits']);
        return true;
      } else if (hasQbuiltRoles) {
        // If the user has QBuilt roles, redirect to QBuilt.
        this.router.navigate(['cqms']);
        return true;
      } else if (hasQbuiltInspectorRoles) {
        this.router.navigate(['cqms-home']);
        return true;
      } else {
        this.redirectToErrorPage();
        return false;
      }
    }
    return true;
  }

  redirectToErrorPage(): void {
    this.router.navigate(['error'], {
      state: {
        errorTitle: 'You do not have permissions to access the requested page.',
        errorMessage: 'Return to ClaytonGO:',
      },
    });
  }
}
